import { useEffect, useState } from "react";

export type TCalendly = {
  initInlineWidget: (o: any) => void;
};

declare global {
  interface Window {
    Calendly?: TCalendly;
  }
}

export const useGetCalendlyApi = () => {
  const [calendlyApi, setCalendlyApi] = useState<TCalendly | null>(null);

  useEffect(() => {
    if (!window.Calendly) {
      const scriptTag = document.createElement("script");
      scriptTag.src = "https://assets.calendly.com/assets/external/widget.js";
      scriptTag.async = true;
      document.body.appendChild(scriptTag);

      const intervalId = setInterval(() => {
        if (window.Calendly) {
          setCalendlyApi(window.Calendly);
          clearInterval(intervalId);
        }
      }, 100);
    } else {
      setCalendlyApi(window.Calendly);
    }
  }, []);

  return calendlyApi;
};
